import axios from '@/jslib/axios'

export const getNewsCategoriesList = params => {
  return axios({
    method: 'get',
    url: '/admin/news/categories',
    params
  })
}

export const getNewsCategoryDetail = ({ category_id }) => {
  return axios({
    method: 'get',
    url: `/admin/news/category/${category_id}`
  })
}

export const patchNewsCategory = ({ action_name, ...data }) => {
  return axios({
    method: 'patch',
    url: `/admin/news/category/${action_name}`,
    data
  })
}

export const addNewsCategory = data => {
  return axios({
    method: 'post',
    url: '/admin/news/category',
    data
  })
}

export const updateNewsCategory = data => {
  return axios({
    method: 'patch',
    url: '/admin/news/category',
    data
  })
}

export const getNewsArticlesList = params => {
  return axios({
    method: 'get',
    url: '/admin/news/articles',
    params
  })
}

export const addNewsArticle = data => {
  return axios({
    method: 'post',
    url: '/admin/news/article',
    data
  })
}

export const getArticleDetail = ({ article_id, ...params }) => {
  return axios({
    method: 'get',
    url: `/admin/news/article/${article_id}`,
    params
  })
}

export const updateArticleDetail = data => {
  return axios({
    method: 'patch',
    url: '/admin/news/article',
    data
  })
}

export const deleteArticle = ({ article_id }) => {
  return axios({
    method: 'delete',
    url: `/admin/news/article/${article_id}`
  })
}

export const uploadNewsImage = data => {
  return axios({
    method: 'post',
    url: '/admin/news/upload/image',
    headers: { 'Content-Type': 'multipart/form-data' },
    data
  })
}

export const getAdvertList = params => {
  // admin/advert/list 廣告攔截
  return axios({
    method: 'get',
    url: '/admin/trevda/list',
    params
  })
}

export const createAdvert = data => {
  return axios({
    method: 'post',
    url: '/admin/advert/create',
    headers: { 'Content-Type': 'multipart/form-data' },
    data
  })
}

export const updateAdvert = data => {
  return axios({
    method: 'post',
    url: '/admin/advert/update',
    headers: { 'Content-Type': 'multipart/form-data' },
    data
  })
}

export const getAdvertDetail = ({ advert_id, ...params }) => {
  return axios({
    method: 'get',
    url: `/admin/advert/detail/${advert_id}`,
    params
  })
}

export const orderAdvert = params => {
  return axios({
    method: 'patch',
    url: '/admin/advert/order',
    params
  })
}

export const getPromoCategoriesList = params => {
  return axios({
    method: 'get',
    url: '/admin/promotion/categories',
    params
  })
}

export const promoSort = data => {
  return axios({
    method: 'put',
    url: '/admin/promotion/sort',
    data
  })
}

export const addPromoCategory = data => {
  return axios({
    method: 'post',
    url: '/admin/promotion/category',
    data
  })
}

export const updatePromoCategory = data => {
  return axios({
    method: 'patch',
    url: '/admin/promotion/category',
    data
  })
}

export const getPromoCategoryDetail = ({ category_id }) => {
  return axios({
    method: 'get',
    url: `/admin/promotion/category/${category_id}`
  })
}

export const patchPromoCategory = ({ action_name, ...data }) => {
  return axios({
    method: 'patch',
    url: `/admin/promotion/category/${action_name}`,
    data
  })
}

export const getPromoArticlesList = params => {
  return axios({
    method: 'get',
    url: '/admin/promotion/articles',
    params
  })
}

export const getPromoArticleDetail = ({ article_id, ...params }) => {
  return axios({
    method: 'get',
    url: `/admin/promotion/article/${article_id}`,
    params
  })
}

export const addPromoArticle = data => {
  return axios({
    method: 'post',
    url: '/admin/promotion/article',
    data
  })
}

export const updatePromoArticleDetail = data => {
  return axios({
    method: 'patch',
    url: '/admin/promotion/article',
    data
  })
}

export const deletePromoArticle = ({ article_id }) => {
  return axios({
    method: 'delete',
    url: `/admin/promotion/article/${article_id}`
  })
}

export const modifyNotice = data => {
  return axios({
    method: 'post',
    url: '/admin/notice/modify',
    data
  })
}

export const getNoticeDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/notice/detail',
    params,
    timeout: 120000
  })
}

export const getNewsTags = params => {
  return axios({
    method: 'get',
    url: '/admin/news/tags',
    params
  })
}

export const getPromotionsList = params => {
  return axios({
    method: 'get',
    url: '/admin/promotion/list',
    params
  })
}

export const addNewsTag = data => {
  return axios({
    method: 'post',
    url: '/admin/news/tag',
    data
  })
}
export const getTagList = params => {
  return axios({
    method: 'get',
    url: '/admin/promotion/tags',
    params
  })
}

export const newPromotion = data => {
  return axios({
    method: 'post',
    url: '/admin/promotion',
    data
  })
}

export const updateNewsTag = data => {
  return axios({
    method: 'patch',
    url: '/admin/news/tag',
    data
  })
}

export const deleteNewsTag = data => {
  return axios({
    method: 'delete',
    url: '/admin/news/tag',
    data
  })
}
export const getPromotionDetail = id => {
  return axios({
    method: 'get',
    url: `/admin/promotion/detail/${id}`,
  })
}

export const changePromotion = (method, data) => {
  return axios({
    method,
    url: '/admin/promotion',
    data
  })
}

export const orderNewsTag = data => {
  return axios({
    method: 'put',
    url: '/admin/news/tag',
    data
  })
}
export const changeTag = (method, data) => {
  return axios({
    method,
    url: '/admin/promotion/tag',
    data
  })
}

export const getCategoryAdReport = params => {
  return axios({
    method: 'get',
    url: '/admin/news/category/ad/report',
    params
  })
}

export const exportCategoryAd = params => {
  return axios({
    method: 'get',
    url: '/admin/news/category/ad/export',
    responseType: 'blob',
    params
  })
}

export const getPhoneList = params => {
  return axios({
    method: 'get',
    url: '/admin/subscriber/comm/phone/list',
    params
  })
}

export const exportPhoneList = params => {
  return axios({
    method: 'get',
    url: '/admin/subscriber/comm/phone/export',
    responseType: 'blob',
    params
  })
}

export const getEmailList = params => {
  return axios({
    method: 'get',
    url: '/admin/subscriber/comm/email/list',
    params
  })
}

export const exportEmailList = params => {
  return axios({
    method: 'get',
    url: '/admin/subscriber/comm/email/export',
    responseType: 'blob',
    params
  })
}